// 人才培训路由
import { talentTrainingRoutes } from './talentTraining'
// 产业园
import { industrialParkRoutes } from './industrialPark'
// 关于我们
import { aboutUsRoutes } from "./aboutUs"
// 产教融合
import { fusionRoutes } from './fusion'

// 系统路由
const routes = [
	{
		path: '/login',
		component: () => import('@/views/auth/login/index.vue'),
		meta: {
			title: '登录'
		}
	},
	{
		path: '/wxMpLogin',
		component: () => import('@/views/auth/login/wxMpLogin.vue'),
		meta: {
			title: '微信通知认证'
		}
	},
	{
		path: '/authSuccess',
		component: () => import('@/views/auth/login/authSuccess.vue'),
		meta: {
			title: '微信通知认证'
		}
	},
	{
		path: '/register',
		component: () => import('@/views/auth/register/register.vue'),
		meta: {
			title: '账户注册'
		}
	},
	{
		path: '/findPassword',
		component: () => import('@/views/auth/findPassword/index.vue'),
		meta: {
			title: '找回密码'
		}
	},
	{
		path: '/filePreview',
		component: () => import('@/views/filePreview/index.vue'),
		meta: {
			title: '预览'
		}
	},
	{
		name: 'layout',
		path: '/',
		component: () => import('@/layout/index.vue'),
		redirect: '/home',
		children: [
			{
				path: '/home',
				component: () => import('@/views/home/index.vue'),
				meta: {
					title: '' //首页
				}
			},
			{
				path: '/agreement',
				component: () => import('@/views/agreement/index.vue'),
				meta: {
					title: '平台协议'
				}
			},
			{
				path: '/infoNotice',
				component: () => import('@/views/infoNotice/index.vue'),
				meta: {
					title: '资讯公告'
				}
			},
			{
				path: '/infoNotice/detail',
				component: () => import('@/views/infoNotice/detail.vue'),
				meta: {
					title: '资讯公告详情'
				}
			},
			{
				path: '/searchJob',
				component: () => import('@/views/searchJob/index.vue'),
				meta: {
					title: '找工作'
				}
			},
			{
				path: '/jobhunting',
				component: () => import('@/views/jobhunting/index.vue'),
				meta: {
					title: '找工作'
				}
			},
			{
				path: '/searchTalents',
				component: () => import('@/views/searchTalents/index.vue'),
				meta: {
					title: '找人才'
				}
			},
			{
				path: '/searchTalents/detail',
				component: () => import('@/views/searchTalents/detail.vue'),
				meta: {
					title: '找人才详情'
				}
			},
			{
				path: '/searchJob/jobDetail',
				component: () => import('@/views/searchJob/jobDetail.vue'),
				meta: {
					title: '岗位详情'
				}
			},
			{
				path: '/searchJob/hrDetail',
				component: () => import('@/views/searchJob/hrDetail.vue'),
				meta: {
					title: 'HR详情'
				}
			},
			{
				path: '/searchJob/firmDetail',
				component: () => import('@/views/searchJob/firmDetail.vue'),
				meta: {
					title: '公司详情'
				}
			},
			{
				path: '/recruitmentFair',
				component: () => import('@/views/recruitmentFair/index.vue'),
				meta: {
					title: '招聘会'
				}
			},
			{
				path: '/recruitmentFairDetail',
				component: () => import('@/views/recruitmentFair/detail.vue'),
				meta: {
					title: '招聘会详情'
				}
			},
			{
				path: '/recruitmentColumn',
				component: () => import('@/views/recruitmentColumn/index.vue'),
				meta: {
					title: '招考专栏'
				}
			},
			{
				path: '/recruitmentColumnDetails',
				component: () => import('@/views/recruitmentColumn/details.vue'),
				meta: {
					title: '招考公告详情'
				}
			},
			{
				path: '/recruitmentColumnPostDetailsUiV',
				component: () => import('@/views/recruitmentColumn/postDetailsUiV.vue'),
				meta: {
					title: '招考岗位详情'
				}
			},
			{
				path: '/recruitmentColumnEnroll',
				component: () => import('@/views/recruitmentColumn/enroll.vue'),
				meta: {
					title: '招考报名'
				}
			},
			{
				path: '/talentService',
				component: () => import('@/views/talentService/index.vue'),
				meta: {
					title: '人才服务'
				}
			},
			{
				path: '/talentService/detail',
				component: () => import('@/views/talentService/detail.vue'),
				meta: {
					title: '人才服务详情'
				}
			},
			{
				path: '/talentService/talentAuthentication',
				component: () => import('@/views/talentService/talentAuthentication/index.vue'),
				meta: {
					title: '人才认证'
				}
			},
			{
				path: '/talentService/enterpriseAuth',
				component: () => import('@/views/talentService/enterpriseAuth/index.vue'),
				meta: {
					title: '企业认证'
				}
			},
			{
				path: '/talentService/activity',
				component: () => import('@/views/talentService/activity.vue'),
				meta: {
					title: '人才疗养活动'
				}
			},
			{
				path: '/talentService/activityDetail',
				component: () => import('@/views/talentService/activityDetail.vue'),
				meta: {
					title: '人才疗养活动详情'
				}
			},
			{
				path: '/talentService/subscribe',
				component: () => import('@/views/talentService/subscribe/index.vue'),
				meta: {
					title: '人才房申购'
				}
			},
			{
				path: '/talentService/talentHousing',
				component: () => import('@/views/talentService/talentHousing/index.vue'),
				meta: {
					title: '人才住房'
				}
			},
			{
				path: '/talentService/weekEngineer',
				component: () => import('@/views/talentService/weekEngineer/index.vue'),
				meta: {
					title: '周末工程师'
				}
			},
			{
				path: '/talentService/projectFund',
				component: () => import('@/views/talentService/projectFund/index.vue'),
				meta: {
					title: '人才项目支持资金'
				}
			},
			{
				path: '/personalCenter/myResume',
				component: () => import('@/views/personalCenter/myResume/index.vue'),
				meta: {
					title: '我的简历'
				}
			},
			{
				path: '/personalCenter/myResumeDetail',
				component: () => import('@/views/personalCenter/myResume/detail.vue'),
				meta: {
					title: '简历详情'
				}
			},
			{
				path: '/pointsMall',
				component: () => import('@/views/pointsMall/index.vue'),
				meta: {
					title: '积分商城'
				}
			},
			{
				path: '/onlineChat',
				component: () => import('@/views/onlineChat/index.vue'),
				meta: {
					title: '在线聊天'
				}
			},
			{
				path: '/personalCenter',
				component: () => import('@/views/personalCenter/index.vue'),
				meta: {
					title: '个人管理中心'
				},
				children: [
					{
						path: '/personalCenter/home',
						component: () => import('@/views/personalCenter/home/index.vue'),
						meta: {
							title: '个人首页'
						}
					},
					{
						path: '/personalCenter/applyJob',
						component: () => import('@/views/personalCenter/applyJob/index.vue'),
						meta: {
							title: '求职管理'
						}
					},
					{
						path: '/personalCenter/collectionAttention',
						component: () => import('@/views/personalCenter/collectionAttention/index.vue'),
						meta: {
							title: '收藏关注'
						}
					},
					{
						path: '/personalCenter/service',
						component: () => import('@/views/personalCenter/service/index.vue'),
						meta: {
							title: '企业服务'
						}
					},
					{
						path: '/personalCenter/privacySetting',
						component: () => import('@/views/personalCenter/privacySetting/index.vue'),
						meta: {
							title: '隐私设置'
						}
					},
					{
						path: '/personalCenter/accountSetting',
						component: () => import('@/views/personalCenter/accountSetting/index.vue'),
						meta: {
							title: '账号管理'
						}
					},
					{
						path: '/personalCenter/myRecruitment',
						component: () => import('@/views/personalCenter/myRecruitment/index.vue'),
						meta: {
							title: '我的招考'
						}
					},
					{
						path: '/personalCenter/myTrain',
						component: () => import('@/views/personalCenter/myTrain/index.vue'),
						meta: {
							title: '我的培训'
						}
					},
					{
						path: '/personalCenter/myIntegral',
						component: () => import('@/views/personalCenter/myIntegral/index.vue'),
						meta: {
							title: '我的积分'
						}
					},
					{
						path: '/personalCenter/realnameAuth',
						component: () => import('@/views/personalCenter/realnameAuth/index.vue'),
						meta: {
							title: '实名认证'
						}
					},
					{
						path: '/personalCenter/practiceTraining',
						component: () => import('@/views/personalCenter/practiceTraining/index.vue'),
						meta: {
							title: '实习实训'
						}
					},
				]
			},
			{
				path: '/firmCenter',
				component: () => import('@/views/firmCenter/index.vue'),
				meta: {
					title: '公司管理中心'
				},
				children: [
					{
						path: '/firmCenter/home',
						component: () => import('@/views/firmCenter/home/index.vue'),
						meta: {
							title: '公司首页'
						}
					},
					{
						path: '/firmCenter/positionManagement',
						component: () => import('@/views/firmCenter/positionManagement/index.vue'),
						meta: {
							title: '职位管理'
						}
					},
					{
						path: '/firmCenter/positionManagement/publishPosition',
						component: () => import('@/views/firmCenter/positionManagement/publishPosition.vue'),
						meta: {
							title: '发布职位'
						}
					},
					{
						path: '/firmCenter/resumeMng',
						component: () => import('@/views/firmCenter/resumeMng/index.vue'),
						meta: {
							title: '简历管理'
						}
					},
					{
						path: '/firmCenter/enterpriseMng',
						component: () => import('@/views/firmCenter/enterpriseMng/index.vue'),
						meta: {
							title: '企业管理'
						}
					},
					{
						path: '/firmCenter/jobFair',
						component: () => import('@/views/firmCenter/jobFair/index.vue'),
						meta: {
							title: '招聘会'
						}
					},
					{
						path: '/firmCenter/talentService',
						component: () => import('@/views/firmCenter/talentService/index.vue'),
						meta: {
							title: '人才服务'
						}
					},
					{
						path: '/firmCenter/myIntegral',
						component: () => import('@/views/firmCenter/myIntegral/index.vue'),
						meta: {
							title: '我的积分'
						}
					},
					{
						path: '/firmCenter/accountSetting',
						component: () => import('@/views/firmCenter/accountSetting/index.vue'),
						meta: {
							title: '账号管理'
						}
					},
					{
						path: '/firmCenter/mainAuth',
						component: () => import('@/views/firmCenter/mainAuth/index.vue'),
						meta: {
							title: '经营主体认证'
						}
					},
					{
						path: '/firmCenter/practiceTraining',
						component: () => import('@/views/firmCenter/practiceTraining/index.vue'),
						meta: {
							title: '实习实训'
						}
					},
					{
						path: '/firmCenter/practiceTraining/form',
						component: () => import('@/views/firmCenter/practiceTraining/form.vue'),
						meta: {
							title: '实习实训公告'
						}
					},
					{
						path: '/firmCenter/survey',
						component: () => import('@/views/firmCenter/survey/index.vue'),
						meta: {
							title: '监测指标汇报'
						}
					},
					{
						path: '/firmCenter/coalesceteachers',
						component: () => import('@/views/firmCenter/coalesceteachers/index.vue'),
						meta: {
							title: '兼职教师库'
						}
					},
					{
						path: '/firmCenter/coalesceteachers/form',
						component: () => import('@/views/firmCenter/coalesceteachers/form.vue'),
						meta: {
							title: '编辑教师'
						}
					},
					{
						path: '/employmenDemand',
						component: () => import('@/views/employmentDemand/index.vue'),
						meta: {
							title: '用工需求'
						}
					},
					{
						path: '/jointAttention',
						component: () => import('@/views/jointAttention/index.vue'),
						meta: {
							title: '共同关注'
						}
					},
				]
			}
		]
	}
]

// 人才培训路由加入系统
routes.push(talentTrainingRoutes)
// 产业园路由加入系统
routes.push(industrialParkRoutes)
// 关于我们路由加入系统
routes.push(aboutUsRoutes)
// 产教融合路由加入系统
routes.push(fusionRoutes)

export default routes
